import React, { useEffect, useState } from "react";
import { BsTelephone, BsFillCalendarMonthFill } from "react-icons/bs";
import { MdOutlineEmail } from "react-icons/md";
import { GoLocation } from "react-icons/go";
import { MdOutlineDoNotDisturbAlt } from "react-icons/md";
import "./Account.scss";
import OrderComp from "../../components/OrderComp/OrderComp";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
const Account = () => {
  const cart = useSelector((state) => state.cart);
  useEffect(() => {
    Addactive();
    showNoOrder();
  });
  const Addactive = () => {
    let AllLinks = document.querySelectorAll("li");
    AllLinks.forEach((Link) => {
      Link.addEventListener("click", () => {
        AllLinks.forEach((clickli) => {
          clickli.classList.remove("active");
          Link.classList.add("active");
        });
      });
    });
  };

  // show no order
  const showNoOrder = () => {
    if (cart.length === 0) {
      setnooreder(true);
    } else {
      setnooreder(false);
    }
  };
  // show clicked li
  const [Account, showAccount] = useState(true);
  const [order, showOrder] = useState(false);
  const [Password, showPassword] = useState(false);
  const [Billing, showBilling] = useState(false);
  const [noorder, setnooreder] = useState(false);

  return (
    <>
      <div className="Account">
        <div className="container">
          <h1>Account</h1>
          <p>
            <span>Enrico Cole,</span>ciseco@gmail.com · Los Angeles, CA
          </p>
          <div className="links">
            <ul>
              <li
                className="active"
                onClick={() =>
                  showAccount(true) &
                  showOrder(false) &
                  showPassword(false) &
                  showBilling(false)
                }
              >
                Account info
              </li>

              <li onClick={() => showOrder(true) & showAccount(false)}>
                My order
              </li>
              <li
                onClick={() =>
                  showPassword(true) & showOrder(false) & showAccount(false)
                }
              >
                Change password
              </li>
              <li
                onClick={() =>
                  showBilling(true) &
                  showPassword(false) &
                  showOrder(false) &
                  showAccount(false)
                }
              >
                Change Billing
              </li>
            </ul>
          </div>
          {Account && (
            <div className="Account_info">
              <h1>Account infomation</h1>
              <form>
                <label>Full name</label>
                <div className="name">
                  <input
                    type="text"
                    placeholder="example:demo"
                    required
                  ></input>
                </div>
                <label>Email</label>
                <div className="email">
                  <span>
                    <MdOutlineEmail />
                  </span>
                  <input
                    type="email"
                    placeholder="example@example.com"
                    required
                  ></input>
                </div>

                <label>Date of birth</label>
                <div className="Date">
                  <span>
                    <BsFillCalendarMonthFill />
                  </span>
                  <input
                    required
                    type="date"
                    placeholder="7/22/2022"
                    className="date"
                  ></input>
                </div>

                <label>Addess</label>
                <div className="Address">
                  <span>
                    <GoLocation />
                  </span>
                  <input type="text" required></input>
                </div>

                <label>Gender</label>
                <select>
                  <option>Male</option>
                  <option>Female</option>
                </select>

                <label>Phone number</label>
                <div className="Phone">
                  <span>
                    <BsTelephone />
                  </span>
                  <input type="text" placeholder="003 888 232" required></input>
                </div>
                <label>About you</label>
                <textarea placeholder="..."></textarea>
                <button className="submit">Update account</button>
              </form>
            </div>
          )}
          {order && (
            <div className="order" style={{ padding: "40px 0px" }}>
              <h2>Order History</h2>
              {cart.map((product) => {
                return (
                  <OrderComp
                    key={product.id}
                    name={product.name.slice(0, 30)}
                    price={product.price.slice(0, 2)}
                    img={product.img}
                  />
                );
              })}

              {noorder && (
                <div className="nooreder">
                  <h1>
                    <br></br>
                    <MdOutlineDoNotDisturbAlt style={{ color: "red" }} />
                    There Is No Order Yet
                  </h1>
                  <Link to={"/OurStore"}>start shopping now</Link>
                </div>
              )}
            </div>
          )}
          {/* start Update password   */}

          {Password && (
            <div className="Update_Password">
              <h1>Update your password</h1>
              <label>Current password</label>
              <input type="password"></input>

              <label>New password</label>
              <input type="password"></input>

              <label>Confirm password</label>
              <input type="password"></input>
              <button className="UpdatePassword">Update Password</button>
            </div>
          )}
          {/* start Payments div */}
          {Billing && (
            <div className="payment">
              <h2>Payments & payouts</h2>
              <p>
                When you receive a payment for a order, we call that payment to
                you a "payout." Our secure payment system supports several
                payout methods, which can be set up below. Go to FAQ.
              </p>

              <p>
                To get paid, you need to set up a payout method releases payouts
                about 24 hours after a guest’s scheduled time. The time it takes
                for the funds to appear in your account depends on your payout
                method. <a href="df">Learn More</a>
                <button className="payment">Add Payout mothod</button>
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Account;
